import {
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
  Badge,
  Stack,
  Popover,
  List,
  ListItem,
  Typography,
  Divider,
  ListItemText,
  Tooltip,
  Button
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useNavigate } from "react-router-dom";
import { graphqlMutation, graphqlQuery } from "../../data/Axios/DynamicService";
import { notificationservice } from "../../config";
import { notificationsAndCount } from "../../data/Axios/queries";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome"; // Added AI icon

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [notifications, setNotifications] = useState({
    notifications: [],
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const roleGroupId = parseInt(decodedToken.RoleGroupId);

   // Check if user has authentication tokens
  const hasAuthTokens = decodedToken.Id !== null;
  
  useEffect(() => {
    let isMounted = true;
    async function fetchAllData() {
      try {
        const notificationsResponse = await graphqlQuery(
          notificationsAndCount,
          notificationservice.uri
        );
        if (isMounted && notificationsResponse) {
          setNotifications(notificationsResponse);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    }
    fetchAllData();
    return () => {
      isMounted = false;
    };
  }, []);

  const handleLogout = () => {
    // Clear localStorage
    localStorage.clear();
    // Clear sessionStorage
    // sessionStorage.clear();
    // Clear cache (if necessary)
    if (caches) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    // Navigate to the login page
    navigate("/login");
  };

  const handleNotificationClick = async (event) => {
    const newAnchorEl = anchorEl ? null : event.currentTarget;
    setAnchorEl(newAnchorEl);

    if (!anchorEl) {
      try {
        // Call the mutation to mark all notifications as read
        const result = await graphqlMutation(
          `mutation MarkNotificationsRead {
            markNotificationsRead {
              notificationId
              userId
              notificationType
              body
              templateId
              isRead
              createdDate
              companyId
              company
            }
          }`,
          notificationservice.uri
        );

        console.log("Mutation Result:", result);

        // Update the notifications state
        setNotifications((prevNotifications) => ({
          ...prevNotifications,
          notifications: prevNotifications.notifications.map(
            (notification) => ({ ...notification, isRead: true })
          ),
          count: 0,
        }));
      } catch (error) {
        console.error("Error marking notifications as read:", error);
        console.log(
          "Detailed Error Info:",
          error.response?.data || error.message
        );
      }
    }
  };
  const handleMcbSwitch = () => {
    navigate("/MCB-Switch");
  };
  const handlePersonDetailsOpen = () => {
    navigate("/profile");
    setIsProfileOpen(true);
  };

  const handlePersonDetailsClose = () => {
    navigate("/super-admin-dashboard");
    setIsProfileOpen(false);
  };

  const handleIconClick = () => {
    if (isProfileOpen) {
      handlePersonDetailsClose();
    } else {
      handlePersonDetailsOpen();
    }
  };
    // Function to handle AI feature click with token passing
  const handleAIClick = () => {
    // Get the authentication tokens from localStorage
    const authTokens = localStorage.getItem("authTokens");
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    
    const encodedDecodedToken = encodeURIComponent(decodedToken.Id || '');
    console.log("DecodedToke:",decodedToken)
    console.log("UserId:", decodedToken.Id)
    // Construct the URL with tokens as parameters
    const aiUrl = `https://ai.sababisha.com/?UserId=${encodedDecodedToken}`;
    
    //https://ai.sababisha.com/
    // Open the AI feature in a new tab
    window.open(aiUrl, "_blank");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Box
      display="flex"
      justifyContent={isSmallScreen ? "space-evenly" : "space-between"}
      p={2}
    >
      {/* Sababisha AI Feature Link */}
      {hasAuthTokens && (
        <Box display="flex" alignItems="center" mr={2}>
          <Tooltip title="Try our new AI feature">
            <Button
              variant="outlined"
              startIcon={<AutoAwesomeIcon />}
              onClick={handleAIClick}
              sx={{
                color: colors.greenAccent[400],
                borderColor: colors.greenAccent[400],
                '&:hover': {
                  backgroundColor: colors.greenAccent[800],
                  borderColor: colors.greenAccent[400],
                }
              }}
            >
              Try Sababisha AI
            </Button>
          </Tooltip>
        </Box>
      )}
      <Box display="flex" backgroundColor={colors.grey[800]} borderRadius="3px">
        {/* <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" /> */}
        {/* <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton> */}
      </Box>
      <Stack spacing={2} direction="row">
        <Tooltip title="Change Theme">
          <IconButton onClick={colorMode.toggleColorMode}>
            {theme.palette.mode === "dark" ? (
              <DarkModeOutlinedIcon />
            ) : (
              <LightModeOutlinedIcon />
            )}
          </IconButton>
        </Tooltip>

        <Tooltip title="Notifications">
          <IconButton aria-describedby={id} onClick={handleNotificationClick}>
            <Badge
              badgeContent={open ? 0 : notifications.count}
              color="secondary"
            >
              <NotificationsOutlinedIcon color="action" />
            </Badge>
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Logout">
          <IconButton onClick={handleLogout}>
            <LogoutOutlinedIcon />
          </IconButton>
        </Tooltip>
        
        {roleGroupId === 1 && (
          <Tooltip title="MCB Switch">
            <IconButton onClick={handleMcbSwitch}>
            <ExitToAppIcon />
          </IconButton>
          </Tooltip>
          
        )}

        <Tooltip title="Profile">
          <IconButton onClick={handleIconClick}>
            <PersonOutlinedIcon />
          </IconButton>
        </Tooltip>
      </Stack>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box
          p={2}
          sx={{
            width: "300px",
            borderRadius: "0.75rem",
            bgcolor:
              theme.palette.mode === "light"
                ? colors.blueAccent[900]
                : colors.grey[600],
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
              color: colors.greenAccent[400],
            }}
            variant="h6"
          >
            Notifications
          </Typography>
          <List>
            {notifications.notifications?.map((notification) => (
              <div key={notification.notificationId}>
                <ListItem>
                  <ListItemText primary={notification.body} />
                </ListItem>
                <Divider
                  sx={{
                    color: colors.redAccent[400],
                  }}
                />
              </div>
            ))}
          </List>
        </Box>
      </Popover>
    </Box>
  );
};

export default Topbar;
